/** @prettier */
import React, { useState } from 'react';
import { Modal } from 'antd';
import { connect } from 'react-redux';
import { withFormik } from 'formik';
import Papa from 'papaparse';
import hostedTablesActions from 'redux/hostedTables/actions';
import EditHostedTableForm from './EditHostedTableForm';
import HostedTablePreview from './HostedTablePreview';

const EditHostedTable = ({
  isEditPopup,
  setEditForm,
  tableName,
  editHostedTable,
  maxColumnsCount,
  maxRowsCount,
  showPreview,
  step,
  setStep,
  file,
  delimiter,
  containsHeader,
  truncateTableInExasol,
}) => {
  const handleCancel = () => {
    setEditForm('', false);
  };

  const kFormatter = (num) => {
    return Math.abs(num) > 999
      ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + 'K'
      : Math.sign(num) * Math.abs(num);
  };

  const readCSV = (file, delimiter) => {
    return new Promise((resolve) => {
      Papa.parse(file, {
        header: false,
        delimiter,
        dynamicTyping: true,
        complete: function (results) {
          resolve(results);
        },
      });
    });
  };

  const validate = async (values) => {
    const errors = {};

    if (values.containsHeader) {
      maxRowsCount = maxRowsCount + 1;
    }

    if (values.file === null) {
      errors['file'] = 'CSV file is Required';
    } else if (values.file !== null && values.file.type.toLowerCase() !== 'text/csv') {
      errors['file'] = 'Only CSV file is allowed';
    } else {
      let csvData = await readCSV(values.file, values.delimiter);

      if (csvData.errors.length > 0 && csvData.data.length && csvData.data[0].length !== 1) {
        errors['file'] = 'CSV must contain valid data';
      } else if (csvData.data.length > maxRowsCount) {
        errors['file'] = 'CSV should not contain records more than ' + kFormatter(maxRowsCount);
      } else if (csvData.data[0].length > maxColumnsCount) {
        errors['file'] = 'CSV should not contain columns more than ' + maxColumnsCount;
      }
    }

    if (values.containsHeader) {
      maxRowsCount = maxRowsCount - 1;
    }

    return errors;
  };

  const initialValues = {
    tableName,
    containsHeader,
    truncateTableInExasol,
    file,
    delimiter,
  };

  const FormikForm = withFormik({
    mapPropsToValues: () => initialValues,
    handleSubmit: (rawValues) => {
      editHostedTable(
        rawValues.tableName,
        rawValues.containsHeader,
        rawValues.file,
        rawValues.truncateTableInExasol,
        rawValues.delimiter
      );
    },
    validate,
    initialValues,
  })(EditHostedTableForm);

  return (
    <Modal
      className="rc-upload-hosted-lookup-table-popup"
      visible={isEditPopup}
      title="Upload Hosted Lookup Table Data"
      onCancel={handleCancel}
      footer={null}
      maskClosable={false}
      width={800}
    >
      {step !== 3 && <FormikForm setEditForm={setEditForm} showPreview={showPreview} />}
      {step === 3 && <HostedTablePreview setStep={setStep} cancelForm={handleCancel} />}
    </Modal>
  );
};

const mapStatetoProps = (state) => ({
  file: state.hostedTables.file,
  delimiter: state.hostedTables.delimiter,
  containsHeader: state.hostedTables.containsHeader,
  step: state.hostedTables.step,
  truncateTableInExasol: state.hostedTables.truncateTableInExasol,
  isEditPopup: state.hostedTables.isEditPopup,
  tableName: state.hostedTables.tableName,
  maxColumnsCount: state.hostedTables.maxColumnsCount,
  maxRowsCount: state.hostedTables.maxRowsCount,
});

const mapDispathTopProps = (dispatch) => ({
  setEditForm: (tableName, isEditPopup) => dispatch(hostedTablesActions.setEditForm(tableName, isEditPopup)),
  editHostedTable: (...data) => dispatch(hostedTablesActions.editHostedTable(...data)),
  showPreview: (file, delimiter, containsHeader, tableName) =>
    dispatch(hostedTablesActions.showPreview(file, delimiter, containsHeader, tableName)),
  setStep: (step) => dispatch(hostedTablesActions.setStep(step)),
});

export default connect(mapStatetoProps, mapDispathTopProps)(EditHostedTable);
